export const plotTabs = {
  overview: 'overview',
  application: 'application',
  documents: 'documents',
  thread: 'thread',
} as const
